/**
 * Chiaro o scuro, e chi lo decide.
 *
 * Il tema deve essere applicato PRIMA che la pagina si disegni, altrimenti si vede un lampo
 * bianco a ogni ricarica prima che passi allo scuro: e' il difetto piu' visibile che ha una
 * modalita' scura fatta a meta'. Per questo vive qui e non nel negozio, che nasce vuoto e
 * viene riempito dopo.
 *
 * Sta nel browser e non nelle preferenze dell'utenza, a differenza per esempio della vista dei
 * messaggi, per due ragioni:
 *
 *   - va applicato anche sulla pagina di accesso, dove non c'e' ancora nessuno da cui leggere
 *     una preferenza;
 *   - e' davvero una scelta del dispositivo: lo stesso lavoro si guarda chiaro dal monitor in
 *     ufficio e scuro dal telefono la sera.
 */
const CHIAVE = "zoelia_tema";

/** Cosa preferisce il sistema operativo, se lo dice. */
function preferenzaDiSistema() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

/**
 * Il tema con cui partire: quello scelto, o quello del sistema.
 *
 * <p>Alla prima visita non si impone il chiaro. Chi tiene il computer in scuro se lo aspetta
 * scuro anche qui, e doverlo dire una seconda volta a ogni applicazione e' una piccola
 * scortesia che si nota.</p>
 */
export function temaIniziale() {
  try {
    const salvato = localStorage.getItem(CHIAVE);
    if (salvato === "dark" || salvato === "light") return salvato;
  } catch (e) {
    // Navigazione in incognito con i dati dei siti bloccati: si ripiega sul sistema.
  }
  return preferenzaDiSistema();
}

/**
 * Scrive il tema sul documento.
 *
 * <p>Due attributi: data-bs-theme e' quello di Bootstrap e tinge i componenti, data-topbar lo
 * guarda Velzon per la barra in alto, che altrimenti resterebbe bianca sopra una pagina scura.
 *
 * <p><b>Non si tocca data-sidebar</b>, che sembrerebbe il terzo della serie e non lo e': in
 * Velzon non dice il tema, dice il COLORE della barra laterale, ed e' una scelta a se' che si
 * fa dal pannello delle impostazioni. In Zoelia il menu e' scuro anche col tema chiaro:
 * legarlo al tema avrebbe reso il menu bianco tornando al chiaro, cioe' cambiato l'aspetto
 * dell'applicazione a tutti per via di un pulsante che doveva fare un'altra cosa.</p>
 */
export function applicaTema(tema) {
  const radice = document.documentElement;
  radice.setAttribute("data-bs-theme", tema);
  radice.setAttribute("data-topbar", tema);
}

export function salvaTema(tema) {
  try {
    localStorage.setItem(CHIAVE, tema);
  } catch (e) {
    // Non poterlo ricordare non e' una buona ragione per non cambiarlo adesso.
  }
}

/**
 * Segue il sistema finche' nessuno ha scelto a mano.
 *
 * <p>Chi passa a scuro alle sei di sera se lo ritrova scuro anche qui, senza toccare niente.
 * Appena si preme il pulsante la scelta diventa esplicita e il sistema smette di comandare:
 * il contrario — cambiare sotto le mani a chi aveva deciso — sarebbe un difetto.</p>
 */
export function seguiIlSistema(quandoCambia) {
  if (!window.matchMedia) return () => {};
  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const ascoltatore = (e) => {
    try {
      if (localStorage.getItem(CHIAVE)) return;
    } catch (err) {
      // Non si riesce a leggere: si segue comunque il sistema, che e' il comportamento di serie.
    }
    quandoCambia(e.matches ? "dark" : "light");
  };
  media.addEventListener("change", ascoltatore);
  return () => media.removeEventListener("change", ascoltatore);
}
